import {
	comMapping
} from "@/components/util/Function/comMapping";

export function getdata() {
	var obj = {
		headData: [{
				title: "具体分类",
				prop: "jtfl",
				width: 360,
				align: "left",
			},
			{
				title: "项目A",
				width: "80",
				AmountFormat: true,
				align: "right",
				prop: "tes1",
				custom: true
			},
			{
				title: "项目B",
				width: "80",
				AmountFormat: true,
				align: "right",
				prop: "tes2",
				custom: true
			},
			{
				title: "项目C",
				width: "80",
				AmountFormat: true,
				align: "right",
				prop: "tes3",
				custom: true
			},
			{
				title: "项目D",
				width: "80",
				AmountFormat: true,
				align: "right",
				prop: "tes4",
				custom: true
			},
			{
				title: "项目E",
				width: "80",
				AmountFormat: true,
				align: "right",
				prop: "tes5",
				custom: true
			}
		],
		tableData: [
			{ jtfl: '（一）人员人工费用（4+5+6）',name:'xmwd_0_1_3',},
			{ jtfl: '1.直接从事研发活动人员工资薪金', name:'xmwd_0_1_4'},
			{ jtfl: '2.直接从事研发活动人员五险一金', name:'xmwd_0_1_5'},
			{ jtfl: '3.外聘研发人员的劳务费用' ,name:'xmwd_0_1_6'},
			{ jtfl: '（二）直接投入费用（8+9+10+11+12+13+14+15）',name:'xmwd_0_1_7' },
			{ jtfl: '1.研发活动直接消耗材料费用',name:'xmwd_0_1_8' },
			{ jtfl: '2.研发活动直接消耗燃料费用',name:'xmwd_0_1_9' },
			{ jtfl: '3.研发活动直接消耗动力费用' ,name:'xmwd_0_1_10'},
			{ jtfl: '4.用于中间试验和产品试制的模具、工艺装备开发及制造费',name:'xmwd_0_1_11' },
			{ jtfl: '5.用于不构成固定资产的样品、样机及一般测试手段购置费' ,name:'xmwd_0_1_12'},
			{ jtfl: '6.用于试制产品的检验费',name:'xmwd_0_1_13' },
			{ jtfl: '7.用于研发活动的仪器、设备的运行维护、调整、检验、维修等费用',name:'xmwd_0_1_14' },
			{ jtfl: '8.通过经营租赁方式租入的用于研发活动的仪器、设备租赁费',name:'xmwd_0_1_15' },
			{ jtfl: '（三）折旧费用（17+18）',name:'xmwd_0_1_16' },
			{ jtfl: '1.用于研发活动的仪器的折旧费' ,name:'xmwd_0_1_17'},
			{ jtfl: '2.用于研发活动的设备的折旧费',name:'xmwd_0_1_18' },
			{ jtfl: '（四）无形资产摊销（20+21+22）',name:'xmwd_0_1_19' },
			{ jtfl: '1.用于研发活动的软件的摊销费用' ,name:'xmwd_0_1_20'},
			{ jtfl: '2.用于研发活动的专利权的摊销费用' ,name:'xmwd_0_1_21'},
			{ jtfl: '3.用于研发活动的非专利技术（包括许可证、专有技术、设计和计算方法等）的摊销费用' ,name:'xmwd_0_1_22'},
			{ jtfl: '（五）新产品设计费等（24+25+26+27）' ,name:'xmwd_0_1_23'},
			{ jtfl: '1.新产品设计费' ,name:'xmwd_0_1_24'},
			{ jtfl: '2.新工艺规程制定费' ,name:'xmwd_0_1_25'},
			{ jtfl: '3.新药研制的临床试验费' ,name:'xmwd_0_1_26'},
			{ jtfl: '4.勘探开发技术的现场试验费' ,name:'xmwd_0_1_27'},
			{ jtfl: '（六）其他相关费用(29+30+31+32+33)' ,name:'xmwd_0_1_28'},
			{ jtfl: '1.技术图书资料费、资料翻译费、专家咨询费、高新科技研发保险费' ,name:'xmwd_0_1_29'},
			{ jtfl: '2.研发成果的检索、分析、评议、论证、鉴定、评审、评估、验收费用',name:'xmwd_0_1_30' },
			{ jtfl: '3.知识产权的申请费、注册费、代理费' ,name:'xmwd_0_1_31'},
			{ jtfl: '4.职工福利费、补充养老保险费、补充医疗保险费' ,name:'xmwd_0_1_32'},
			{ jtfl: '5.差旅费、会议费',name:'xmwd_0_1_33' },
			{ jtfl: '（七）经限额调整后的其他相关费用',name:'xmwd_0_1_34' }
		],
	}
	return obj
}
